/* Table scroll shadow ----------------------------------------------- */
// This uses/requires https://github.com/gauthierblanpain/table-scroll-shadow
// So we import it:
// import "./node_modules/table-scroll-shadow/dist/table-scroll-shadow.min.js";
import "../../../node_modules/table-scroll-shadow/dist/table-scroll-shadow.min.js";

// But in order for it to work, we need to have two wrappers around
// the table. CKEditor already provides one: <figure class="table">
// So we need to add one outside of that...

// Call in <figure class="table"> and add a second class to it
var el = document.querySelector('figure.table');

// Put it in a conditional to make sure the element exists
if(typeof(el) != 'undefined' && el != null) {
	el.classList.add('table-scroll');

	// Create the wrapper around <figure class="table">
	// and add a class to it
	var wrapper = document.createElement('div');
	wrapper.classList.add('table-wrapper');

	// Insert the wrapper before el in the DOM tree
	el.parentNode.insertBefore(wrapper, el);

	// Move el (<figure class="table">) into wrapper
	wrapper.appendChild(el);

	// Now we reference/initialize the table scroll shadow
	const table = new TableScrollShadow()
	table.init()
}
